/** Numéro national lisible : « 0590271234 » → « 0590 27 12 34 » (toute autre forme est rendue telle quelle). */
export const fmtPhone = (n) => {
  const d = String(n || "").replace(/\D/g, "");
  return d.length === 10 ? `${d.slice(0, 4)} ${d.slice(4, 6)} ${d.slice(6, 8)} ${d.slice(8)}` : String(n || "");
};
